import { useMemo } from 'react'
import { useThemeStore } from '@/store/themeStore'

/**
 * Colores de Chart.js según el tema del portal.
 *
 * Chart.js pinta en un `<canvas>`: no lee las clases `dark:` ni las variables CSS, así que una
 * gráfica con colores fijos se quedaba con la rejilla y los números del tema claro sobre el fondo
 * azul marino (ilegible). Este hook devuelve la paleta del tema ACTIVO y, como cambia cuando cambia
 * `isDark`, la gráfica que lo usa se vuelve a pintar sola al cambiar de tema.
 *
 * Los valores son fijos por tema (no `getComputedStyle`) a propósito: leer la variable en el render
 * puede llegar antes de que `.dark` esté aplicada en `<html>` y devolver el color del tema anterior.
 * Si cambia la paleta de `index.css`, hay que tocarlos aquí también.
 */
const PALETA = {
  claro: {
    linea: '#B8924A',
    relleno: 'rgba(184,146,74,0.15)',
    grid: 'rgba(15,30,72,0.08)',
    ticks: '#6B675E',
    tooltipBg: '#0F1E48',
    tooltipText: '#FFFFFF',
  },
  oscuro: {
    linea: '#D4B06A',
    relleno: 'rgba(212,176,106,0.18)',
    grid: 'rgba(230,234,242,0.08)',
    ticks: '#8B97AD',
    tooltipBg: '#E6EAF2',
    tooltipText: '#0B1220',
  },
}

/** `{ grid, ticks, linea, relleno, tooltipBg, tooltipText, isDark }` del tema activo. */
export function useTemaGraficas() {
  const isDark = useThemeStore((s) => s.isDark)
  return useMemo(() => ({ ...(isDark ? PALETA.oscuro : PALETA.claro), isDark }), [isDark])
}

export default useTemaGraficas
